// extracted by mini-css-extract-plugin
export default {"dropdown":"Dropdown_dropdown__Y+Idf","dark":"Dropdown_dark__ihTDE"};